import { createFileRoute } from "@tanstack/react-router";
import { ReposicaoPage } from "@/paginas/reposicao";

export const Route = createFileRoute("/_authenticated/reposicao")({
  head: () => ({
    meta: [
      { title: "Reposição de estoque — Milky Moo Palmares" },
      {
        name: "description",
        content:
          "Contagem de reposição: informe a quantidade existente e a recebida de cada insumo e ajuste o estoque do local.",
      },
      { property: "og:title", content: "Reposição de estoque — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Contagem de reposição de insumos com ajuste automático do estoque do local.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: ReposicaoPage,
});
